import React from 'react';
import './Education.css';

const Education: React.FC = () => {
  return (
    <section id="education" className="education section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Education</h2>
          <div className="section-underline"></div>
        </div>
        
        <div className="education-content">
          <div className="education-grid">
            {/* Education Item 1 */}
            <div className="education-item">
              <div className="education-icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <div className="education-details">
                <h3>Master of Computer Science</h3>
                <h4>University of Technology</h4>
                <p className="education-date">2019 - 2021</p>
                <p className="education-description">
                  Specialized in Artificial Intelligence and Machine Learning. Graduated with distinction, 
                  completing a thesis on efficient neural network architectures for edge computing.
                </p>
                <div className="education-achievements">
                  <span>Dean's List</span>
                  <span>Research Award</span>
                </div>
              </div>
            </div>
            
            {/* Education Item 2 */}
            <div className="education-item">
              <div className="education-icon">
                <i className="fas fa-university"></i>
              </div>
              <div className="education-details">
                <h3>Bachelor of Science in Computer Engineering</h3>
                <h4>State University</h4>
                <p className="education-date">2015 - 2019</p>
                <p className="education-description">
                  Comprehensive program covering both hardware and software aspects of computing systems.
                  Graduated cum laude with a focus on distributed systems and network security.
                </p>
                <div className="education-achievements">
                  <span>3.85 GPA</span>
                  <span>Honors Program</span>
                </div>
              </div>
            </div>
            
            {/* Education Item 3 */}
            <div className="education-item">
              <div className="education-icon">
                <i className="fas fa-certificate"></i>
              </div>
              <div className="education-details">
                <h3>Professional Certifications</h3>
                <h4>Various Platforms</h4>
                <p className="education-date">2018 - Present</p>
                <p className="education-description">
                  Actively pursuing professional development through industry-recognized certifications 
                  in cloud architecture, machine learning, and security best practices.
                </p>
                <div className="education-achievements">
                  <span>AWS Certified Solutions Architect</span>
                  <span>Google Cloud Professional Developer</span>
                  <span>Advanced Security Practitioner</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education; 